import styled from 'styled-components';

export const Container = styled.div`
    position: absolute;
    bottom: -158px;
    left: 50%;
    z-index: 100;
    height: 160px;
    min-width: 500px;
    background-color: #111;
    border: 1px solid #333;
    transform: translate3d(-50%, 0, 0);
    transition: all .3s ease 0s;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: stretch;

    &.opened {
        bottom: 0;
    }

    &.timerOpened {
        left: calc(50% - 135px);
    }
`;

export const Header = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: stretch;
    width: 100%;
    height: 20px;
    border-bottom: 1px solid #333;
`;

export const MainHeader = styled.div`
    text-transform: uppercase;
    color: #777;
    font-size: 10px;
    padding: 5px;
    width: 300px;
`;


export const SideHeader = styled.div`
    text-transform: uppercase;
    color: #777;
    border-left: 1px solid #333;
    font-size: 10px;
    padding: 5px;
    width: 200px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
`;

export const Content = styled.div`
    flex: 1;
    display: flex;
    flex-direction: row;
    align-items: stretch;
    justify-content: stretch;
`;

export const Carousel = styled.div`
    height: 100%;
    width: 300px;
    display: flex;
    flex-direction: row;
    align-items: stretch;
    justify-content: stretch;
`;

export const Listing = styled.div`
    height: 100%;
    width: 200px;
    border-left: 1px solid #333;
`;

export const ButtonCarousel = styled.div`
    height: 100%;
    width: 40px;
    border-left: 1px solid #333;
    border-right: 1px solid #333;
    position: relative;
    cursor: pointer;

    :hover {
        background-color: #333;
    }

    &:before {
        content: "${props => props.icon || '\\F04E5'}";
        font-family: "Material Design Icons";
        font-size: 20px;
        position: absolute;
        color: #fff;
        width: 100%;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        padding: 0;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
    }
`;

export const SideHeaderTitle = styled.div`
`;

export const SideHeaderValue = styled.div`
    color: #fff;
    padding-right: 13px;
`;